import React from "react";
import { AppBar, Button } from '@mui/material'

const Navbar = () => {



    return (
        <AppBar style={{ flexDirection: 'row', padding: 5, justifyContent: "space-between", position: 'sticky', backgroundColor: '#fff' }}>
            <Button disableElevation sx={{ borderBottom: 3, borderBottomColor: '#302E2EFF', fontSize: 12, color: '#302E2EFF' }} href='#' color='#302E2EFF' variant='contained' size='small'>All</Button>
            <Button disableElevation sx={{ fontSize: 12, color: '#302E2EFF' }} href='#' color='#302E2EFF' variant='contained' size='small'>Cars</Button>
            <Button disableElevation sx={{ fontSize: 12, color: '#302E2EFF' }} href='#' color='#302E2EFF' variant='contained' size='small'>Parts</Button>
            <Button disableElevation sx={{ fontSize: 12, color: '#302E2EFF' }} href='#' color='#302E2EFF' variant='contained' size='small'>Trucks</Button>

        </AppBar>

    );
};

export default Navbar;


